import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Header from './Header';
import { Link } from 'react-router-dom';
import { Typography } from '@material-ui/core';

const styles = theme => ({
  root: {
    flexGrow: 1,
    padding: theme.spacing.unit,
    paddingTop: theme.spacing.unit*10,
  },
  button: {
    margin: theme.spacing.unit * 1,
  },
  caption: {
    textAlign: "center",
    width: "100%",
  },
});

function ComplexGrid(props) {
  const { classes, user } = props;
  return (
    <React.Fragment>
      <Header user={user} />
      <Grid container justify="center" alignItems="center" direction="row" className={classes.root}>
          <Grid className={classes.caption}>
          <Typography component="h2" variant="h5" gutterBottom>
            Make your own games,<br/>Play, Share and Compete. 
          </Typography>
          </Grid>
          <Grid className={classes.button}>
          <Button variant="contained" color="primary" className={classes.button} component={Link} to="/list">
            Play
          </Button>
          <Button variant="contained" color="secondary" className={classes.button} component={Link} to="/make">
            Make
          </Button>
          </Grid>
      </Grid>
    </React.Fragment>
  );
}

ComplexGrid.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ComplexGrid);
